import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-bl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-bl.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationDetailsBlConstants } from "./create-application-details-bl.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../shared/models/alert";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationDetailsBlComponent = class CreateApplicationDetailsBlComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    searchApplicationsService;
    detailsForm;
    validationMessages = CreateApplicationDetailsBlConstants.VALIDATION_MESSAGES;
    detailsFormGroupName = CreateApplicationDetailsBlConstants.DETAILS_FORM_GROUP_NAME;
    descriptionFormControlName = CreateApplicationDetailsBlConstants.DESCRIPTION_FORM_CONTROL_NAME;
    typeFormControlName = CreateApplicationDetailsBlConstants.TYPE_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    descriptionLabel = CreateApplicationDetailsBlConstants.DESCRIPTION_LABEL;
    typeLabel = CreateApplicationDetailsBlConstants.TYPE_LABEL;
    tradeNameLabel = CreateApplicationDetailsBlConstants.TRADE_NAME_LABEL;
    tradeNameFormControlName = CreateApplicationDetailsBlConstants.TRADE_NAME_CONTROL;
    businessOwnerLabel = CreateApplicationDetailsBlConstants.BUSINESS_OWNER_LABEL;
    businessOwnerFormControlName = CreateApplicationDetailsBlConstants.BUSINESS_OWNER_CONTROL;
    businessOwnerHeading = CreateApplicationDetailsBlConstants.BUSINESS_OWNER_HEADING;
    businessOwnerDisableFilterBy = true;
    businessOwnerDisableEditing = false;
    businessOwnerGroups = [];
    applicationTypes = [];
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        if (this.detailsForm.pristine || this.isApplicationLoadedFromTheSearchPage) {
            // this is either the first time this step is loaded or it is being loaded from the search page
            this.getLookups();
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has(CreateApplicationDetailsBlConstants.APPLICATION_TYPE_LOOKUP_NAME)) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsBlConstants.APPLICATION_TYPE_LOOKUP_NAME);
            }
            else {
                this.getLookups();
            }
        }
        this.setupSubscribers();
    }
    loadMetadata(stepMeta) {
        try {
            this.businessOwnerGroups = stepMeta.businessOwnerGroup;
            this.changeDetectorRef.detectChanges();
        }
        catch (e) {
            this.appControllerService.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(CreateApplicationDetailsBlConstants.DETAILS_FORM_GROUP_NAME);
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and deleted eq false`,
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsBlConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.trim().toLowerCase() === `${CreateApplicationDetailsBlConstants.APPLICATION_TYPE_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
            });
            this.applicationTypes = applicationTypes;
            applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
            this.aflaModuleStrategyService.lookups.set(CreateApplicationDetailsBlConstants.APPLICATION_TYPE_LOOKUP_NAME, this.applicationTypes);
            if (this.isApplicationLoadedFromTheSearchPage) {
                // only run when the application is loaded from the search page
                this.checkApplicationData();
            }
            this.changeDetectorRef.detectChanges();
        }
    }
    checkApplicationData() {
        const isFormPristine = this.detailsForm.pristine;
        const isFormUnTouched = this.detailsForm.untouched;
        const isFormInvalid = this.detailsForm.invalid;
        if (isFormPristine && isFormUnTouched && isFormInvalid) {
            this.updateFormData();
        }
    }
    updateFormData() {
        this.detailsForm.get(this.descriptionFormControlName).setValue(this.selectedApplication.description);
        this.detailsForm.get(this.typeFormControlName).setValue(this.selectedApplication.type);
        this.detailsForm.get(this.tradeNameFormControlName).setValue(this.selectedApplication.tradeName);
        this.detailsForm.get(this.businessOwnerFormControlName).setValue(this.selectedApplication.businessOwner[0]);
    }
    setupSubscribers() {
        this.subscribeToCheckFormValidity();
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.detailsForm && formGroupName === this.detailsFormGroupName) {
                    this.detailsForm.markAllAsTouched();
                    this.changeDetectorRef.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsBlComponent = __decorate([
    Component({
        selector: "app-create-application-details-bl",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsBlComponent);
export { CreateApplicationDetailsBlComponent };
